import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import { BlockTypes } from 'enum/block-type.enum'
import {
  BlockMultimediaContent,
  ProgressLessonContent,
} from 'store/states/lessons.state'
import { useAccess } from 'contexts/AccessContext'
import { useIsLastLessonHigher } from './useIsLastLessonHigher'

export const useMultimediaProgress = () => {
  const currentLessonContent = useSelector(
    ({ lmsLessons }: IMainState) => lmsLessons.currentLessonContent
  )

  const progress = useSelector(
    ({ progressLessonContent }: IMainState) => progressLessonContent.progress
  )

  const isLastLessonHigher = useIsLastLessonHigher()

  const lessonsMultimedia = useMemo(() => {
    if (!currentLessonContent || !Array.isArray(currentLessonContent)) {
      return new Map()
    }
    const multimedia = currentLessonContent.filter(
      (block) => block && block.type === BlockTypes.BlockMultimedia
    )
    return new Map(multimedia.map((block) => [+block.id, block]))
  }, [currentLessonContent])

  const finished = useMemo(() => {
    if (isLastLessonHigher) return true
    for (const key in progress) {
      const lesson = lessonsMultimedia.get(+key)
      if (
        lesson?.type === BlockTypes.BlockMultimedia &&
        !!lesson.lockProgress
      ) {
        const isFinalized = isMultimediaFinalized(lesson, progress[key])
        if (!isFinalized) return false
      }
    }
    return true
  }, [isLastLessonHigher, lessonsMultimedia, progress])

  return { finished, isLastLessonHigher }
}

export function isMultimediaFinalized(
  lesson: BlockMultimediaContent,
  progressLessonContent: ProgressLessonContent
) {
  const { lockProgress, fileData } = lesson
  const { currentTime, duration } = progressLessonContent

  const finalized = currentTime >= duration * 0.9 && lockProgress && !!fileData
  return finalized
}

export const useAccessToPreview = () => {
  const { access, loading } = useAccess()

  const isAllowedToPreview = access.canPreviewCourse()

  return { isAllowedToPreview, loading }
}

export * from './useIsLastLessonHigher'
